/* TJ shared B2B/B2C smart header: direction-driven, not an idle timer. */
(function(){
 'use strict';
 function setup(){
   if(document.documentElement.dataset.tjSmartStarted)return;
   var mobile=document.getElementById('tj-mobile-mega');
   var float=document.getElementById('tj-smart-floating-header');
   if(!mobile||!float)return;
   document.documentElement.dataset.tjSmartStarted='1';
   var body=document.body, lastY=Math.max(0,window.scrollY||0);
   var lastDirection=0,travel=0,frame=false,visible=false;
   var topLimit=16,activation=64,travelNeeded=11;
   function smallScreen(){return window.matchMedia('(max-width:749px)').matches}
   function interacting(){
     if(body.classList.contains('tjmn-open'))return true;
     if(mobile.classList.contains('is-searching'))return true;
     if(document.querySelector('#cart-drawer.active,#searchPopup.active,.mobile-nav-wrapper.active'))return true;
     var focused=document.activeElement;
     return focused&&focused!==document.body&&focused.matches('input,textarea,select,[contenteditable="true"]');
   }
   function apply(){
     var y=Math.max(0,window.scrollY||window.pageYOffset||0);
     var m=smallScreen();
     var dy=y-lastY; lastY=y;
     if(y<=topLimit){
       visible=false;travel=0;lastDirection=0;
     } else if(interacting()){
       visible=true;travel=0;lastDirection=0;
     } else if(y>activation&&Math.abs(dy)>1){
       var direction=dy>0?1:-1;
       if(direction!==lastDirection){travel=0;lastDirection=direction}
       travel+=Math.abs(dy);
       if(travel>=travelNeeded){visible=direction<0;travel=0;}
     }
     body.classList.toggle('tj-smart-show',visible&&y>topLimit);
     mobile.classList.toggle('tj-smart-hidden',m&&y>topLimit&&!visible);
     float.setAttribute('aria-hidden',!m&&visible&&y>topLimit?'false':'true');
     if(!m&&visible&&y>topLimit){float.removeAttribute('inert')}
     else{float.setAttribute('inert','')}
   }
   function schedule(){
     if(frame)return;
     frame=true;
     window.requestAnimationFrame(function(){frame=false;apply()});
   }
   body.classList.add('tj-smart-header-ready');
   if(lastY>activation){visible=false}
   apply();
   window.addEventListener('scroll',schedule,{passive:true});
   window.addEventListener('resize',function(){lastY=window.scrollY||0;travel=0;lastDirection=0;schedule()},{passive:true});
   document.addEventListener('click',function(e){
     var cart=e.target.closest('#tj-smart-floating-header .tj-smart-cart');
     if(!cart)return;
     if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
     var drawer=document.getElementById('cart-drawer');
     if(!drawer)return;
     e.preventDefault();e.stopPropagation();
     var nowOpen=!drawer.classList.contains('active');
     drawer.classList.toggle('active',nowOpen);
     cart.setAttribute('aria-expanded',nowOpen?'true':'false');
   });
   document.addEventListener('click',function(e){
     var drawer=document.getElementById('cart-drawer');
     if(!drawer||!drawer.classList.contains('active'))return;
     if(drawer.contains(e.target)||e.target.closest('#tj-smart-floating-header .tj-smart-cart'))return;
     drawer.classList.remove('active');
     var btn=float.querySelector('.tj-smart-cart');if(btn)btn.setAttribute('aria-expanded','false');
   });
   document.addEventListener('keydown',function(e){
     if(e.key!=='Escape')return;
     var drawer=document.getElementById('cart-drawer');
     if(drawer&&drawer.classList.contains('active')){drawer.classList.remove('active');var btn=float.querySelector('.tj-smart-cart');if(btn)btn.setAttribute('aria-expanded','false')}
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);
 else setup();
})();